// A step kind's display label — shared by the Steps section's cards and the
// results page's step summary cards.

import type { StepKind } from "@/api/types";

export const KIND_LABELS: Record<StepKind, string> = {
    choice: "Choice",
    multi: "Multi-select",
    text: "Text",
};
